/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Box, Flex, Heading, Text, VStack } from '@chakra-ui/react';
import { Divider } from '@diamond/shared/ui';
import { buyerCurrencyFormatter } from '@diamond/shared/utils';

type RingkasanTagihanProps = {
  savedTotal: number;
  originalSubtotal: number;
  finalSubtotal: number;
  originalTotal?: number;
  hasPromoOrVoucher?: boolean;
};

export function RingkasanTagihan({
  savedTotal,
  originalSubtotal,
  finalSubtotal,
  originalTotal,
  hasPromoOrVoucher,
}: RingkasanTagihanProps) {
  const showHemat = savedTotal !== 0;
  const showTotal =
    (originalSubtotal !== 0 && originalSubtotal !== finalSubtotal) || showHemat;
  const showTotalAwal =
    originalTotal !== undefined && originalTotal !== finalSubtotal;

  return (
    <Box mx={{ base: 0, md: 6 }}>
      <Divider display={{ base: 'none', md: 'block' }} borderColor="gray.33" />
      <Flex
        mt={{ base: hasPromoOrVoucher ? '30px' : '0px', md: '30px' }}
        flexDir={{ base: 'column', md: 'row' }}
        justifyContent="space-between"
      >
        <Box>
          <Heading
            size={{ base: 'xs', md: 'xs' }}
            fontSize="14px"
            color="rgba(55, 63, 65, 1)"
          >
            Ringkasan Tagihan
          </Heading>
          <Text
            display={{ base: 'none', lg: 'block' }}
            mt={1}
            fontWeight="400"
            fontStyle="normal"
            fontSize="12px"
            lineHeight="100%"
            letterSpacing="0%"
            color="#8E8E93"
          >
            Harga satuan pada PO dan faktur dapat berbeda karena perhitungan
            pembulatan.
          </Text>
        </Box>
        <VStack mt={{ base: 4, md: 0 }}>
          <>
            {showTotal && (
              <Flex gap="6" w="full" alignItems="center">
                <Text color="gray" fontSize={{ base: 'xs', md: 'sm' }}>
                  Sub Total
                </Text>
                <Text
                  flex="1"
                  color={{ base: '#999999', md: 'gray' }}
                  textAlign="right"
                  fontWeight="bold"
                  fontSize={{ base: 'xs', md: 'sm' }}
                  textDecor="line-through"
                >
                  {buyerCurrencyFormatter(originalSubtotal)}
                </Text>
              </Flex>
            )}

            {showHemat && (
              <Flex gap="6" w="full" alignItems="center">
                <Text color="gray" fontSize={{ base: 'xs', md: 'sm' }}>
                  Hemat
                </Text>
                <Text
                  flex="1"
                  textAlign="right"
                  fontWeight="bold"
                  color="red"
                  fontSize={{ base: 'xs', md: 'sm' }}
                >
                  {buyerCurrencyFormatter(savedTotal)}
                </Text>
              </Flex>
            )}

            <Flex gap="6" w="full" alignItems="center">
              <Text color="gray" fontSize={{ base: 'xs', md: 'sm' }}>
                {showHemat ? 'Total Tagihan Final' : 'Total Tagihan'}
              </Text>
              <Text
                flex="1"
                textAlign="right"
                fontWeight={{ base: 700, md: 'bold' }}
                fontSize={{ base: '14px', md: '18px' }}
                color={{ base: '#131415', md: 'inherit' }}
              >
                {buyerCurrencyFormatter(finalSubtotal)}
              </Text>
            </Flex>

            {showTotalAwal && (
              <Flex gap="6" w="full" alignItems="center">
                <Text color="gray" fontSize="sm">
                  Tagihan Awal
                </Text>
                <Text
                  flex="1"
                  textAlign="right"
                  fontWeight="bold"
                  fontSize="xs"
                  color="gray"
                >
                  {buyerCurrencyFormatter(originalTotal)}
                </Text>
              </Flex>
            )}
          </>
        </VStack>
      </Flex>
    </Box>
  );
}
